import React from 'react'
import { Form, Formik, useFormikContext } from 'formik'
import Menu from './Menu'
import ProgramStep from './steps/ProgramStep'
import Debug from './Debug'
import t from './translate'
import Contacts from './Contacts'
import * as yup from 'yup'
import { focusElement } from './utils/focusElement'
import programSchema from './schema/program'
import dataSchema from './schema/data'
import overviewSchema from './schema/overview';
import sendSchema from './schema/send';
import DataStep from './steps/DataStep'
import OverviewStep from './steps/OverviewStep'
import SendStep from './steps/SendStep'
import ConfirmationStep from './steps/ConfirmationStep'
import Expired from './steps/Expired'

function Save ({ save }) {
  if (process.env.NODE_ENV === 'development') {
    const { values } = useFormikContext()

    let saveValues = () => {
      save(values)
    }

    return <div>
      <div onClick={saveValues} className="save"
          style={{ 'cursor': 'pointer' }}>{t('save')}</div>
      <Debug title={'Form Values'} values={values}/>
    </div>
  }
}

function Remove ({ remove }) {
  if (process.env.NODE_ENV === 'development') {

    let removeValues = () => {
      remove()
      location.reload();
    }
    
    return <div>
      <div onClick={removeValues} className="remove"
          style={{ 'cursor': 'pointer' }}>{t('remove')}</div>
    </div>
  }
}

function Back ({ click }) {
  return <button type={'button'} onClick={click} className="back">{t('back')}</button>
}

function Forward ({ isSendStep, onClick }) {
  let buttonText = isSendStep ? t('send.button.text') : t('forward');
  return <button type="submit" onClick={onClick} className="forward">{buttonText}</button>
}

function ErrorMessage() {
  return <div className='errorMessage mt-1 mb-1'><span>{t('errors.label')}</span></div>
}
export default class Application extends React.Component {
  steps = ['program', 'data', 'overview', 'send', 'confirmation']
  storageKeyValues = 'wings-values'
  storageVersion = 2.0;

  constructor (props) {
    super(props)
    this.initialValues = this.loadStorageValues()

    let currentProgram = false

    if(this.initialValues.program && this.initialValues.program.code) {
      currentProgram = this.getProgram(this.initialValues.program.code)
    }

    this.state = {
      currentStep: 0,
      highestStep: 0,
      currentProgram: currentProgram,
    }
    this.formRef = React.createRef();
    let currentStep = false
    let i = 0;
    if(this.initialValues.forceRestart) {
      window.location.hash = "";
    } else {
      this.steps.forEach(function (el) {
        if (el === (window.location.hash || "#").substring(1)){
          currentStep = i;
        }
        i++;
      });
    }

    if(currentStep) {
      this.setStep(currentStep);
    }

    window.addEventListener("hashchange", this.handleHashChange);

  }

  handleHashChange = () => {
    let currentStep = 0
    let i = 0;
    this.steps.forEach(function (el) {
      if (el === (window.location.hash || "#").substring(1)){
        currentStep = i;
      }
      i++;
    });
    this.setState({currentStep: currentStep});
  }

  loadStorageValues = () => {
    const values = JSON.parse(localStorage.getItem(this.storageKeyValues)) || {}
    const currentDate = new Date();
    const cacheDate = values.storageKeyDate ? new Date(values.storageKeyDate) : currentDate;
    const diffInDays = Math.floor((currentDate - cacheDate) / (1000 * 3600 * 24));

    if (values.version == this.storageVersion && diffInDays <= 1) {
      values.file = ''
      values.sessionExpired = false;
      values.forceRestart = false;
      values.storageKeyDate = currentDate.toISOString();

      // remove attachments on init
      if (values.send?.attachments) {
        values.send.attachments.resume = []
        values.send.attachments.grades = []
        values.send.attachments.miscellaneous = []
      }

      return values
    } else {
      return { 'version': this.storageVersion, 'forceRestart': true, 'storageKeyDate': currentDate.toISOString()}
    }
  }

  handleForward(errors, values) {
    this.saveValues(values)
    if(Object.keys(errors).length > 0) {
      this.formRef.current.classList.add('validating-form');
      focusElement(errors);
      return false;
    } else {
      this.formRef.current.classList.remove('validating-form');
      return true;
    }
  }

  saveValues = values => {
    localStorage.setItem(this.storageKeyValues, JSON.stringify(values))
  }

  deleteCache = (values = {}) => {
    localStorage.removeItem(this.storageKeyValues)
    values.program = {}
    values.data = {}
    values.send = {}

    this.state = {
      currentStep: 0,
      highestStep: 0,
      currentProgram: null,
    }
  }

  setStep = id => {
    let state = this.state
    if (id >= 0 && id < this.steps.length) {
      state.currentStep = id
    }

    if (id > this.state.highestStep) {
      state.highestStep = id
    }

    window.removeEventListener("hashchange", this.handleHashChange);
    window.location.hash = `#${this.steps[this.state.currentStep]}`
    window.addEventListener("hashchange", this.handleHashChange);

    this.setState(state)
  }

  isLastStep = () => {
    return this.state.currentStep >= this.steps.length - 1
  }

  isSendStep = () => {
    return this.state.currentStep == this.steps.length - 2
  }

  isFirstStep = () => {
    return this.state.currentStep <= 0
  }

  nextStep = () => {
    if (!this.isLastStep()) {
      global.window.document.querySelector('.menu')?.scrollIntoView({ behavior: 'instant' });
      this.setStep(this.state.currentStep + 1)
    }
  }

  previousStep = () => {
    if (!this.isFirstStep()) {
      this.setStep(this.state.currentStep - 1)
    }
  }

  cleanDomestics = (values, setFieldValue) => {
    let domestics = values.data?.studies?.previousStudies?.domestic?.filter(item => {
        for (let key in item) {
            if (typeof item[key] === 'string' && item[key].trim() === '') {
                delete item[key];
            }
        }
        return Object.keys(item).length > 0;
    });

    setFieldValue('data.studies.previousStudies.domestic', domestics)
  }

  handleSubmit = (values, { setFieldValue }) => {
    if(values.data?.personal?.insurance?.insured == 'false') {
        delete values.data.personal.insurance.companyName;
        delete values.data.personal.insurance.company;
        delete values.data.personal.insurance.number;
    }
    
    this.cleanDomestics(values, setFieldValue);
    if (!this.isLastStep()) {
      this.nextStep()
    }
  }

  stepSchema = () => {
    let shape = {}
    if (this.state.currentStep === 0) {
      shape.program = programSchema(this.state.currentProgram, this.props.programs)
    }
    
    if (this.state.currentStep === 1) {
      shape.data = dataSchema(this.state.currentProgram, this.props.programs, this.props.countries, this.props.locations)
    }

    if (this.state.currentStep === 2) {
      shape.overview = overviewSchema()
    }

    if (this.state.currentStep === 3) {
      shape.program = programSchema(this.state.currentProgram, this.props.programs, this.props.locations)
      shape.data = dataSchema(this.state.currentProgram, this.props.programs, this.props.countries, this.props.locations)
      shape.send = sendSchema(this.state.currentProgram, this.props.programs, this.props.countries, this.props.locations)
    }

    return yup.object().required().shape(shape)
  }

  getProgram = code => {
    let program = this.props.programs.find(element => element.code == code)
    return program
  }

  onProgramChange = async (program) => {
    const newProgram = this.getProgram(program);

    this.setState({ currentProgram: newProgram }, async () => {
        if (!newProgram?.prices) {
            await this.loadPrices(newProgram);
        }

        if (!newProgram?.contacts) {
            await this.loadContacts(newProgram);
        }
    });
  };

  async loadCourses() {
    let state = this.state;
    if(state.currentProgram) {
      await fetch("/api/application/courses?kuerzel=" + state.currentProgram.kuerzel)
        .then(response => response.json())
        .then(data => {
          state.currentProgram.courses = data;
          this.setState(state);
        })
        .catch(error => {
          console.error(error);
          state.failed = true;
          this.setState(state);
        });
    }
  }

  async loadPrices() {
    let state = this.state;
    if(state.currentProgram) {
      await fetch("/api/application/prices?preisliste=" + state.currentProgram.preisliste)
        .then(response => response.json())
        .then(data => {
          state.currentProgram.prices = data;
          this.setState(state);
        })
        .catch(error => {
          console.error(error);
          state.failed = true;
          this.setState(state);
        });
    }
  }

  async loadContacts() {
    if (!this.state.currentProgram) {
      this.setState(prevState => ({
        currentProgram: {
          ...prevState.currentProgram,
          contacts: this.props.contacts ?? []
        }
      }));
      return;
    }

    try {
      const response = await fetch("/api/application/contacts?id=" + this.state.currentProgram.id_betreuer);
      const data = await response.json();
      this.setState(prevState => ({
        currentProgram: {
          ...prevState.currentProgram,
          contacts: [
            ...(data ?? []),
            ...(this.props.contacts ?? [])
          ]
        }
      }));
    } catch (error) {
      this.setState({ failed: true });
    }
  }

  async componentDidMount() {
      await this.loadContacts();
  }
  
  render () {
    return (
        <Formik
          initialValues={this.initialValues}
          onSubmit={this.handleSubmit}
          validateOnBlur={true}
          validateOnChange={true}
          validationSchema={this.stepSchema}
        >
          {({ errors, isValid, validateForm, values}) => (
            <Form ref={this.formRef} noValidate={true}>
              {!values.sessionExpired && 
                <Menu steps={this.steps} currentStep={this.state.currentStep}
                    setStep={this.setStep} highestStep={this.state.highestStep} errors={errors}/>
              }
              <div className="form">
                {(() => {
                  if(values.sessionExpired) {
                    return <Expired />
                  }
                  switch (this.state.currentStep) {
                    case 0:
                      return <ProgramStep onProgramChange={this.onProgramChange}
                                          programs={this.props.programs}
                                          locations={this.props.locations}
                                          currentProgram={this.state.currentProgram}
                      />
                    case 1:
                      return <DataStep program={this.state.currentProgram}
                                       countries={this.props.countries}
                                       allAccordionsActive={this.state.allAccordionsActive}
                                       errors={errors}/>
                    case 2:
                      return <OverviewStep setStep={(step) => this.setStep(step)} program={this.state.currentProgram} locations={this.props.locations} countries={this.props.countries} healthInsurances={this.props.healthInsurances} />
                    case 3:
                      return <SendStep errors={errors} program={this.state.currentProgram}/>
                    case 4:
                      return <ConfirmationStep program={this.state.currentProgram} programs={this.props.programs} countries={this.props.countries} locations={this.props.locations} deleteCache={this.deleteCache}/>
                  }
                })()}
              </div>
              {!isValid && <ErrorMessage/>}
              <div style={{ 'display': 'flex' }}>
                {(!this.isLastStep() && !values.sessionExpired) && 
                <>
                  <div>
                    {!this.isFirstStep() && <Back click={this.previousStep}/>}
                  </div>
                  <div>
                    <Forward isSendStep={this.isSendStep()} onClick={async (e) => { 
                      e.preventDefault();
                      const errors = await validateForm();
                      const canContinue = this.handleForward(errors, values);
                      if (canContinue) {
                        this.formRef.current.requestSubmit();
                      }
                    }}/>
                    <Remove remove={this.deleteCache}/>
                    <Save save={this.saveValues}/>
                  </div>
                </>
                }
              </div>
              <Contacts program={this.state.currentProgram} contacts={this.state.currentProgram?.contacts}/>
              <Debug title="Application Values" values={this.state}/>
            </Form>
          )}
        </Formik>
    )
  }
}
